import React from 'react';

function Hash20(props) {
	const fill = props.fill || 'currentColor';
	const secondaryfill = props.secondaryfill || fill;
	const strokewidth = props.strokewidth || 1;
	const width = props.width || '100%';
	const height = props.height || '100%';
	const title = props.title || "hash 20";

	return (
		<svg height={height} width={width} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
	<title>{title}</title>
	<g fill={secondaryfill} stroke={secondaryfill} strokeLinecap="round" strokeLinejoin="round" strokeWidth={strokewidth} transform="translate(0.5 0.5)">
		<path d="M5.81 18.26l2.49-16.6" fill="none" stroke={fill}/>
		<path d="M11.62 18.26l2.49-16.6" fill="none" stroke={fill}/>
		<path d="M4.15 6.64h12.45" fill="none" stroke={fill}/>
		<path d="M3.32 13.28h12.45" fill="none" stroke={fill}/>
	</g>
</svg>
	);
};

export default Hash20;